import React from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Body = styled.main`
  position: relative;
  width: 100%;
  min-height: calc(100vh - 38px);
  background: ${({ theme }) => theme.bg};
  overflow: hidden;
  padding-bottom: 0;
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 260px;
    background: linear-gradient(180deg, rgba(28, 28, 39, 0) 0%, rgba(8, 9, 17, 0.95) 80%);
    pointer-events: none;
  }
`;

const BackgroundGlow = styled.div`
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 20%, rgba(133, 76, 230, 0.25), transparent 55%),
    radial-gradient(circle at 80% 0%, rgba(0, 70, 209, 0.2), transparent 45%);
  opacity: 0.5;
  pointer-events: none;
`;

const Content = styled.div`
  position: relative;
  z-index: 1;
  padding-bottom: 80px;
`;

const MainLayout = () => (
  <>
    <Navbar />
    <Body>
      <BackgroundGlow />
      <Content>
        <Outlet />
      </Content>
    </Body>
    <Footer />
  </>
);

export default MainLayout;

